import { Monitor, Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useTheme } from '@/hooks/useTheme';

const LABEL = {
  dark: 'Dark theme — switch to light',
  light: 'Light theme — follow system next',
  system: 'Following system theme — switch to dark',
} as const;

export function ThemeToggle() {
  const { preference, toggleTheme } = useTheme();
  const Icon = preference === 'dark' ? Moon : preference === 'light' ? Sun : Monitor;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label={LABEL[preference]}>
            <Icon className="h-4 w-4" aria-hidden />
          </Button>
        }
      />
      <TooltipContent>{LABEL[preference]}</TooltipContent>
    </Tooltip>
  );
}
